<template>
	<v-card
		ripple
		:class="['elevation-0', 'add-item-button', size, {disabled:disabled}]">
		<div 
			:class="['button__content', {centered:centered}]">
			<p class="subheading grid-b">{{label}}</p>
			<div class="conent--icon">
				<v-icon class="grey--text grid-a" size="34px">{{ icon }}</v-icon>
			</div>
		</div>
	</v-card>
</template>


<script>
	export default {
		name: 'add-item-button',
		
		props: {
			label: {
				type: String,
				default: ''
			},
			icon: {
				type: String,
				default: 'add'
			},
			centered: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: 'small'
			},
			disabled: {
				type: Boolean,
				default: false
			}
		}
	}
</script>